<section class="reservation-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <h2>Prenota un tavolo Ora!</h2>
        <a href="https://www.thefork.it/ristorante/borgo-buonanotte-r495185" target="_blank" class="btn btn-primary" data-toggle="modal" data-target="#reservationModal">Prenota Adesso</a>
    </div>
</section>
